"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeRateDiscountedAmount = exports.computeAbsoluteDiscountedAmount = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var big_numbers_1 = require("../../../utils/big-numbers");
var computeAbsoluteDiscountedAmount = function (itemPrice, discountValue, totalPriceWithDiscount) {
    // For Absolute Discount, discountedAmount = discountAmount * (productPrice / sumAllProductsPrices)
    return discountValue.multipliedBy(itemPrice.dividedBy(totalPriceWithDiscount));
};
exports.computeAbsoluteDiscountedAmount = computeAbsoluteDiscountedAmount;
var computeRateDiscountedAmount = function (itemPrice, discountValue, threshold, ceiling, totalPriceWithDiscount) {
    if (threshold === void 0) { threshold = 0; }
    if (ceiling === void 0) { ceiling = null; }
    if (totalPriceWithDiscount === void 0) { totalPriceWithDiscount = new bignumber_js_1.default(0); }
    // negative threshold is not allowed
    threshold = Math.max(threshold, 0);
    var itemRatio = itemPrice.dividedBy(totalPriceWithDiscount);
    var itemThreshold = new bignumber_js_1.default(threshold).multipliedBy(itemRatio);
    // For Rate Discount, discountedAmount = minimum(ceiling, (price - threshold) * rate)
    var amountBeforeCeiling = itemPrice.minus(itemThreshold).multipliedBy(discountValue.dividedBy(big_numbers_1.big10000));
    if (ceiling === null) {
        // if ceiling is null, we consider it equals +infinity
        return amountBeforeCeiling;
    }
    if (ceiling < 0) {
        return big_numbers_1.big0;
    }
    var itemCeiling = new bignumber_js_1.default(ceiling).multipliedBy(itemRatio);
    return bignumber_js_1.default.minimum(amountBeforeCeiling, itemCeiling);
};
exports.computeRateDiscountedAmount = computeRateDiscountedAmount;
